import { version } from "./package.mjs";
//#region src/version.ts
const PACKAGE_VERSION = version;
//#endregion
export { PACKAGE_VERSION };
